<template>
    <div class="page home-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="settingsData">
                    <v-card flat class="bordered px-lg-3">
                        
                        <v-card-title class="mb-1 medium-title">
                            <!-- <v-icon color="primary" size="24" class="me-1">mdi-facebook</v-icon> -->
                            <span>إعدادات SEO (محركات البحث)</span>
                        </v-card-title>
                        <v-card-subtitle class="details-text px-5">إعدادات الظهور على محركات البحث وظهور الروابط في منصات التواصل الاجتماعي</v-card-subtitle>
                        <v-divider class="mx-5 my-1"></v-divider>

                        <v-card-text class="pb-6">
                            <v-list class="pa-0 transparent ma-0" max-width="800">
                                <settings-item flat is-textarea nullable :data="settingsData" name="seo_description" icon="mdi-text-box-outline" color="primary" title="وصف المتجر" subtitle="وصف يظهر أسفل عنوان المتجر عند مشاركة رابط المتجر وفي محركات البحث" @sync="sync"/>
                                <settings-item flat nullable :data="settingsData" name="google_analytics_code" color="amber darken-3" title="Google Analytics" subtitle="أدخل كود Google Analytics الخاص بحسابك (Tracking Id) مثل: UA-128426139-1 ، اترك الحقل فارغاً لإلغاء الربط مع Google Analytics" @sync="sync">
                                    <template slot="icon">
                                        <v-img width="24" height="24" src="/img/analytics_standard_icon.png"></v-img>
                                    </template>
                                </settings-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </div>
            </transition>
      </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import SettingsItem from '@/components/default/settings-item'


export default {
    name: "SeoSettings",
    components: {
        SettingsItem,
    },
    data(){
        return {
            loading: false,
        }
    },
    computed: {
        ...GlobalComputed,
        settingsData(){
            return this.$store.state.storeModule.settings;
        },

    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('getStoreSettings').then(response=>{
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات', 'error');
                })
            }
        },
        sync(data){
            this.$store.commit('UPDATE_STORE_SETTINGS', data);
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        updatingLogo(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
